/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getNotificationSettingsSyncValue} from '../api'

 export const useQueryGetNotificationSettingsSyncValue = createReactQueryHook('getNotificationSettingsSyncValue', getNotificationSettingsSyncValue)
